import { render, staticRenderFns } from "./AppBibleToolProfile.vue?vue&type=template&id=69675b44&"
import script from "./AppBibleToolProfile.vue?vue&type=script&lang=js&"
export * from "./AppBibleToolProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports